import script from "./SkolkovoHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./SkolkovoHeader.vue?vue&type=script&lang=ts&setup=true"

import "./SkolkovoHeader.vue?vue&type=style&index=0&id=10b8f2d8&lang=sass"

const __exports__ = script;

export default __exports__